import type { TabelaPrecoResponse } from '@triade/contracts';
import { estruturadaNaData } from '@/components/destino-tributario/destino';
import { useConsulta } from './base';

/**
 * A tabela e ESTRUTURADA na data da operacao? GET /tabelas-preco/:id (so leitura, mesma chave da consulta de tabela).
 * Nulo enquanto carrega ou sem vigencia na data: a tela nao mostra os seletores de UF e contribuinte nesse caso.
 */
export function useTabelaEstruturada(tabelaId: string | undefined, data: string): boolean | null {
  const consulta = useConsulta<TabelaPrecoResponse>(['tabelas-preco', tabelaId], `/tabelas-preco/${tabelaId}`, { ativo: !!tabelaId });
  return estruturadaNaData(consulta.data, data);
}
